import React, { useEffect, useState } from 'react';
import { BlazeAuthContextProvider } from './BlazeAuthContext';
import { checkIfLoggedIn } from '../../utils';

const BlazeAuthContextWrapper = ({ children }) => {
  const [showRefreshLoginModal, setShowRefreshLoginModal] = useState(false);

  useEffect(() => {
    const isLoggedInTimeout = setInterval(async () => {
      const { isLoggedIn } = checkIfLoggedIn();

      if (!isLoggedIn && !showRefreshLoginModal) {
        setShowRefreshLoginModal(true);
      }
    }, 1000);

    return () => {
      clearTimeout(isLoggedInTimeout);
    };
  }, [showRefreshLoginModal]);

  return (
    <BlazeAuthContextProvider
      value={{
        showRefreshLoginModal,
        setShowRefreshLoginModal
      }}>
      {children}
    </BlazeAuthContextProvider>
  );
};

export default BlazeAuthContextWrapper;
